import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageviewsettingsService } from 'src/app/services/pageviewsettings.service';

import { forkJoin } from 'rxjs';
import { TenantService } from '../services/tenant.service';
import * as Globals from '../../globals';

declare let analytics: any;

interface PageSettings {
  backgroundimage: string;
  choosesectionbgcolor: string;
  fontsize: string;
  title: string;
  subtitle: string;
  // plans: Plan[];
  whyHusky: { title: string; description: string }[];
}

interface broadbandPlan {
  planName: string;
  provider: string;
  disclosure: string;
  monthlyPrice: string;
  monthlyPriceNote: string;
  additionalFees: {
    label: string;
    amount: string;
  }[]
  ;
  governmentTaxes: string;
  speeds: {
    download: string;
    upload: string;
    latency: string;
  };
  dataIncluded: string;
  networkPolicyUrl: string;
  privacyPolicyUrl: string;
  support: {
    phone: string;
    website: string;
  }
  code: string;
}

interface CardDetail {
  text: string;
}

type planData = '5GB' | '10GB' | '15GB' | '30GB';

@Component({
  selector: 'app-alumni-plans',
  templateUrl: './alumni-plans.component.html',
  styleUrls: ['./alumni-plans.component.css']
})

export class AlumniPlansComponent {
  pageSettings: any = {};
  logoPrimaryImageUrl = '';
	logoSecondaryImageUrl = '';
  bannerimageurl = '';
  showCards = false;
  tenantId: any;
  affiliateId: any;
  colors: { name: string; color: string }[] = [
    { name: "huskymobile", color: "#4b2e83" },
    { name: "osumobile", color: "#550000" },
    { name: "calmobile", color: "#00008b" },
    /* Is hushymobile a type or intentional? */
    { name: "hushymobile", color: "#06402b" },
  ];

  plans: {
    id: number;
    url: string;
    data: string;
    name: string;
    price: number;
    description: string;
    subText: string;
    features: { title: string; description?: string }[]; // optional description
    highlight: boolean;
  }[] = []
  plansdata: any
  plansarray: any[] = []
  images = {
    background: '',
    banner: '',

  };
  plansdata2: any;
  broadbandLabelData: any[] = [];
  selectedPlanName: any;
  broadbanddata: any[] = [];

  ;
  defaultImages = {
    background: '/api/assets/affiliate/1/tenant/1/images/landing-bg.jpg',
    banner: 'assets/landingpageplaceholderimage.png',
    logo: 'assets/schooldarklogo.png'
  };

    getPlanUrl (planId: number) {
    switch (this.tenantId ) {
      case 1: 
        switch (planId) {
          case 7 : return 'https://husky-fan.app.collegiatemobile.com/prepaid?planOfferingId=poff_egWLrRTfhIm8PhF7'
          case 8 : return 'https://husky-fan.app.collegiatemobile.com/prepaid?planOfferingId=poff_Ds2t8nKwlhrGv023';
          case 9 : return 'https://husky-fan.app.collegiatemobile.com/prepaid?planOfferingId=poff_RnfklbXu9dQYhkON';
          case 10 : return 'https://husky-fan.app.collegiatemobile.com/prepaid?planOfferingId=poff_XVPXT579A07U1HE9';
          default: return '';
        }
      case 2: 
        switch (planId) {
          case 7 : return 'https://bears-fan.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_NMFNG6DWBMAOLW33'
          case 8 : return 'https://bears-fan.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_QXF1PF3PZ610WP78';
          case 9 : return 'https://bears-fan.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_41P9HEX47KZVPMEE';
          case 10 : return 'https://bears-fan.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_H0YBJBN835F8MCS2';
          default: return '';
        }
      case 3: 
        switch (planId) {
          case 7 : return 'https://beavs-fan.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_G87QOCDLEGJ2O148'
          case 8 : return 'https://beavs-fan.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_IUI75K253A3OJE2K';
          case 9 : return 'https://beavs-fan.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_V0GV5I905PA0819F';
          case 10 : return 'https://beavs-fan.app.collegiatemobile.com/prepaid/create-your-account?planOfferingId=poff_H0ZV6WU4GB3KXGNE';
          default: return '';
        }
      default: return '';

    }
  }


customerType: string = 'Alumni';
loadeddata: any;
tenantName: string = window.location.href.split('/')[3]; // TODO: Find a better way to do this.
tenant: TenantService;

  @ViewChild('carousel', { static: false }) carouselRef!: ElementRef;
  activeIndex = 0;
  scrollToCard(index: number) {
    const carousel = this.carouselRef.nativeElement as HTMLElement;
    const cardWidth = carousel.children[0].clientWidth + 16; // 16 = spacing
    carousel.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
    this.activeIndex = index;
  }
  getDotClass(i: number) {
    return {
      'w-3 h-3 rounded-full': true,
      'bg-purple-500': this.activeIndex === i,
      'bg-gray-300': this.activeIndex !== i
    };
  }

	constructor(private router: Router, private settingsService: PageviewsettingsService, private route: ActivatedRoute, private tenantService: TenantService) {
		this.tenant = tenantService;
		this.settingsService.getCollegetenantcode(this.tenantName).subscribe(data => {
			this.tenantId = parseInt(data.result.id)
			this.affiliateId = data.result.affiliateId
			this.loadPageSettings();
		});

	}

	ngAfterViewInit() {
    const carousel = this.carouselRef.nativeElement as HTMLElement;


    // Listen to scroll events
    carousel.addEventListener('scroll', () => {
      const scrollLeft = carousel.scrollLeft;
      const cardWidth = carousel.children[0].clientWidth + 16; // 16px gap (space-x-4)
      const index = Math.round(scrollLeft / cardWidth);
      this.activeIndex = index;
    });

  }
  ngOnInit() {

    let collegeName = this.route.snapshot.paramMap.get('collegemobile') || '/defaultpage';

    

    this.settingsService.getCollegetenantcode(collegeName).subscribe(data => {
      this.tenantId = data.id
      this.affiliateId = data.affiliateId
     
      this.settingsService.background$.subscribe(bg => this.images.background = bg);
     
    });
    
  }

  

  data: planData[] = ['30GB', '15GB', '10GB', '5GB'];
  selectedData: number | null = null;

  highlightFirstBold(text: string): string {
    const index = text.indexOf(' ');
    if (index === -1) return `<strong>${text}</strong>`;
    return `<strong>${text.slice(0, index)}</strong>${text.slice(index)}`;
  }



  toggleCards() {
    this.showCards = !this.showCards;
    this.fetchBroadbandFactLabels()
  }


  updatePageContent() {

    const customer = this.customerType || 'student';
    if (!this.plansdata?.planDetails || this.plansdata.planDetails.length === 0) return;
    const titleMap: Record<string, string> = {
      student: this.loadeddata.studentmainsectiontitle,
      // faculty: 'Choose Your Student Plan',
      alumni: this.loadeddata.alumnimainsectiontitle
    };

    const subtitleMap: Record<string, string> = {
      student: this.loadeddata.studentmainsectionsubtitle,
      faculty: 'Flexible plans for academic professionals',
      alumni: this.loadeddata.alumnimainsectionsubtitle
    };
    const plans = this.plansdata.planDetails.map((plan: any, index: number) => {

      return {
        id: plan.mobilePlanId,
        plancode: plan.planCode,
        name: plan.name,
        price: plan.consumerPrice / 100,
        talk: plan.cardDetails?.[1]?.text ?? '',
        text: plan.cardDetails?.[2]?.text ?? '',
        data: plan.cardDetails?.[0]?.text ?? '',
        wifi: plan.cardDetails?.[3]?.text ?? '',
        mobiledata: plan.cardDetails?.[4]?.text ?? '',
        vedio: plan.cardDetails?.[5]?.text ?? '',
        offer: plan.cardDetails?.[6]?.text ?? '',
        contract: plan.cardDetails?.[7]?.text ?? '',
        internationationaltexts: index === 2 && plan.cardDetails?.[7]?.text ? '✔ ' + plan.cardDetails?.[7]?.text : '',
        internationationaldata: index === 2 && plan.cardDetails?.[8]?.text ? '✔ ' + plan.cardDetails?.[8]?.text : '',
        buttonname: ['Get Basic', 'Get Standard', 'Get Premium'][index] ?? 'Get Plan',

      };
    });



    const sharedSettings = {
      backgroundimage: this.loadeddata?.backgroundimage ?? '',
      choosesectionbgcolor: this.loadeddata?.choosesectionbgcolor ?? '',
      fontsize: this.loadeddata?.fontsize ?? '',
      title: titleMap[customer],            // override here
      subtitle: subtitleMap[customer],
      plans,
      whyHusky: [
        { title: 'Special offer one', description: 'Lorem ipsum dolor sit amet consectetur ut et.' },
        { title: 'Special offer one', description: 'Lorem ipsum dolor sit amet consectetur ut et' },
        { title: 'Special offer one', description: 'Lorem ipsum dolor sit amet consectetur ut et' },
        { backgroundcolor: '#4b2e83' }
      ]
    };

    this.pageSettings = sharedSettings;
    this.plans = plans;


  }

  selectData(dataKey: any,): void {
    //  this.selectedData = dataKey;
    this.selectedData = this.selectedData === dataKey ? null : dataKey;
    console.log(this.selectedData)


    this.fetchBroadbandFactLabel(this.selectedData)
  }

  fetchBroadbandFactLabel(planId: any) {
    this.settingsService.getbroadbandplans(planId).subscribe((labelData) => {
      this.broadbandLabelData = labelData.result;

    });
  }
  //  for backup: if toggling is needed
  fetchBroadbandFactLabels() {
    const planIds = [7, 8, 9, 10]; // Replace with your actual plan IDs
    const requests = planIds.map(id => this.settingsService.getbroadbandplans(id));

    forkJoin(requests).subscribe(results => {
      this.broadbanddata = results.map(res => res.result);
      console.log(this.broadbandLabelData);
    });
  }


  loadPageSettings() {

		this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
			this.loadeddata = data.result;
			const color = this.loadeddata?.PrimaryColor;
	
			if (color) {
				document.documentElement.style.setProperty('--primary', color);
			} else {
				document.documentElement.style.setProperty('--primary', 'white');
			}
      });

      this.plans = [
      {
        id: 10,
        url: this.getPlanUrl(10),
        name: 'Fan Unlimited',
        data: '30GB',
        price: 45,
        description: 'Taxes & Fees Included',
        subText: 'Built for frequent travelers, busy professionals, and lifelong ' + this.loadeddata?.ShortNamePlural + '.',
        highlight: true,
        features: [
          { title: '<b>Unlimited Data</b><br>(reduced speeds after 30GB)*' },
          { title: '<b>Up to 15GB Hotspot Data Included</b>' },
          { title: '<b>5GB International Data Roaming*</b>' },
          { title: this.loadeddata?.ShortName === 'Bear' ? '7% Giveback' : '7% ' + this.loadeddata?.CollegeNameAcronym + ' Giveback' },
          { title: 'VIP Perks and Experiences' },
          { title: 'Unlimited Talk & Text' },
          { title: 'Wi-Fi Calling' },
          //  { title: 'Credit Builder Included'}
        ]
      },
      {
        id: 9,
        url: this.getPlanUrl(9),
        name: 'Fan Premium',
        data: '15GB',
        price: 35,
        description: 'Taxes & Fees Included',
        subText: 'Ideal for active fans, remote workers, and side hustlers who want a powerful plan with purpose.',
        highlight: false,
        features: [
          { title: '<b>Unlimited Data</b><br>(reduced speeds after 15GB)*' },
          { title: '<b>Up to 15GB Hotspot Data Included</b>' },
          { title: '<b>3GB International Data Roaming*</b>' },
          { title: this.loadeddata?.ShortName === 'Bear' ? '7% Giveback' : '7% ' + this.loadeddata?.CollegeNameAcronym + ' Giveback' },
          { title: 'VIP Perks and Experiences' },
          { title: 'Unlimited Talk & Text' },
          { title: 'Wi-Fi Calling' },
        ]
      },
      {
        id: 8,
        url: this.getPlanUrl(8),
        name: 'Fan Plus',
        data: '10GB',
        price: 25,
        description: 'Taxes & Fees Included',
        subText: 'For fans on the go-from workdays to weekend getaways.',
        highlight: false,
        features: [
          { title: '<b>Unlimited Data</b><br>(reduced speeds after 10GB)*' },
          { title: '<b>Up to 10GB Hotspot Data Included</b>' },
          { title: this.loadeddata?.ShortName === 'Bear' ? '7% Giveback' : '7% ' + this.loadeddata?.CollegeNameAcronym + ' Giveback' },
          { title: 'VIP Perks and Experiences' },
          { title: 'Unlimited Talk & Text' },
          { title: 'Wi-Fi Calling' },
        ]
      },
      {
        id: 7,
        url: this.getPlanUrl(7),
        name: 'Fan Basic',
        data: '5GB',
        price: 20,
        description: 'Taxes & Fees Included',
        subText: 'Perfect for light users who want to give back to the ' + this.loadeddata?.ShortName + ' community.',
        highlight: false,
        features: [
          { title: '<b>5GB of High-Speed Data</b>' },
          { title: '<b>Up to 5GB Hotspot Data Included</b>' },
          { title: this.loadeddata?.ShortName === 'Bear' ? '7% Giveback' : '7% ' + this.loadeddata?.CollegeNameAcronym + ' Giveback' },
          { title: 'VIP Perks and Experiences' },
          { title: 'Unlimited Talk & Text' },
          { title: 'Wi-Fi Calling' },
        ]
      }

    ];
  }

  selectPlan(plancode: any, value: any) {

    if (value == 'cardhighlighted') {
      this.selectedPlanName = plancode;
      console.log(plancode)

    }

  
    if (value == 'buttonclicked') {
      const url = ` ${plancode}`
      window.location.href = url;
    }

   
  }

  trackevent(event: any) {
    analytics.track(event)
  }
}
